// PA Rules: the routes and the sidebar rows of `wealth.pa-dealing.rules` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.pa-dealing.rules',
    routes: [
        {
            frontend: 'comply',
            path: 'pa-rules',
            lazy: () => import('@/pages/comply/pa-rules/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'pa-rules',
            label: 'PA Rules',
            href: '/comply/pa-rules',
            icon: 'Scale',
            group: 'pa-dealing',
            order: 530,
        },
    ],
});
